// src/aws-config.js
const API_URLS = JSON.parse(process.env.REACT_APP_API_URL);
const API_NAMES = JSON.parse(process.env.REACT_APP_API_NAME);

const REST_APIS = {};

Object.keys(API_URLS).forEach((key) => {
  const apiName = API_NAMES[key];
  if (apiName) {
    REST_APIS[apiName] = {
      endpoint: API_URLS[key],
      region: process.env.REACT_APP_REGION,
    };
  }
});

const awsconfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_OAUTH_DOMAIN,
          scopes: [
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: JSON.parse(
            process.env.REACT_APP_OAUTH_REDIRECT_SIGNIN,
          ),
          redirectSignOut: JSON.parse(
            process.env.REACT_APP_OAUTH_REDIRECT_SIGNOUT,
          ),
          responseType: 'token',
          providers: ['Google'],
        },
      },
    },
  },
  API: {
    REST: REST_APIS,
  },
  Analytics: {
    Kinesis: {
      region: process.env.REACT_APP_REGION,
      bufferSize: 1000,
      flushSize: 100,
      flushInterval: 5000,
      resendLimit: 1,
    },
  },
};

export default awsconfig;
